<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import './assets/css/common.css'
import './assets/js/flexible'
export default {
	
}
</script>


<style lang="scss">
</style>
